import { DefaultMenuList, PharmacistMenuList } from './constants';
import { parse, format } from 'date-fns';
export const returnMenuList = (role) => {
    if (role === 1) {
        return PharmacistMenuList
    } else {
        return DefaultMenuList
    }
}

export const handleMenuNavigation = (item, navigate, setPickerDrawerOpened) => {
    if (item.label === "component.menu.post") {
        setPickerDrawerOpened(true);
    } else {
        navigate(item.url);
    }
};

export const parseToMySQLDateTime = (dateString) => {
    const currentDate = dateString ? parse(dateString, 'dd/MM/yyyy HH:mm', null) : new Date();
    return format(currentDate, 'yyyy-MM-dd HH:mm:ss');
}

//TODO write with date-fns package -> looks better ;)
export const formatDateToDDMMYYYY = (date) => {
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();

    return `${day}/${month}/${year}`;
}

export const isValidURL = (url) => {
    const regex = /^(https?:\/\/)?(www\.)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(:[0-9]{1,5})?(\/[^\s]*)?$/;
    return regex.test(url);
}

export const compressImageToBase64 = async (imageUrl, maxWidth = 800, maxHeight = 800, quality = 0.7) => {
    return new Promise((resolve, reject) => {
        // Create an image element
        const img = new Image();

        // When the image is loaded, compress it
        img.onload = function () {
            // Create a canvas element
            const canvas = document.createElement('canvas');
            const ctx = canvas.getContext('2d');

            let width = img.width;
            let height = img.height;

            // Maintain aspect ratio while resizing
            if (width > height) {
                if (width > maxWidth) {
                    height *= maxWidth / width;
                    width = maxWidth;
                }
            } else {
                if (height > maxHeight) {
                    width *= maxHeight / height;
                    height = maxHeight;
                }
            }

            // Set canvas dimensions
            canvas.width = width;
            canvas.height = height;

            // Draw the image on the canvas
            ctx.drawImage(img, 0, 0, width, height);

            // Compress and convert to base64
            const base64String = canvas.toDataURL('image/jpeg', quality);

            resolve(base64String); // Return the Base64 string
        };

        // Handle errors
        img.onerror = function (err) {
            reject(`Failed to load image: ${err}`);
        };

        // Set the source of the image to the provided URL
        img.crossOrigin = "Anonymous"; // This enables cross-origin requests for images
        img.src = imageUrl;
    });
}

export const returnGenderLabel = (gender) => {
    if (gender == 0) {
        return "Male"
    } else if (gender == 1) {
        return "Female"
    } else {
        return "Diverse"
    }
}

export const convertToLocalDateTime = (dateString) => {
    const currentDate = dateString ? parse(dateString, 'dd.MM.yyyy HH:mm', null) : new Date();
    return format(currentDate, 'dd/MM/yyyy HH:mm');
};

export const getOrderTypeString = (orderType) => {
    const type = typeof orderType === 'string' ? parseInt(orderType, 10) : orderType;

    if (typeof type !== 'number' || isNaN(type) || type < 0 || type > 2) {
        throw new Error('Invalid order type. Must be 0, 1, or 2');
    }

    switch (type) {
        case 0:
            return "Bringzz Pickup";
        case 1:
            return "Bringzz Delivery";
        case 2:
            return "Bringzz Package";
        default:
            throw new Error('Invalid order type. Must be 0, 1, or 2');
    }
}